import { useEffect } from 'react';

import { AndroidBanner } from '../AndroidBanner';
import { DesktopBanner } from '../DesktopBanner';
import { IOSBanner } from '../IOSBanner';

import { useBanner } from './hooks/useBanner';

type Props = {
	sourceLocation: string;
	enabled: boolean;
	androidEnabled: boolean;
};

export const Banner = ({ sourceLocation, enabled, androidEnabled }: Props): React.JSX.Element | null => {
	const {
		data: { isIPhoneUserAgent, isAndroidPhoneUserAgent, isMobileUserAgent, bannerClosed },
		actions: { setBannerClosed, trackBannerEligible },
	} = useBanner();

	// Track when the user is eligible for the banner so that we can use the
	// presence of that event to determine which users are in our cohorts
	// for the experiment.
	useEffect(() => trackBannerEligible(), [trackBannerEligible]);

	if (bannerClosed || !enabled) return null;

	return (
		<>
			{isIPhoneUserAgent && <IOSBanner sourceLocation={sourceLocation} setBannerClosed={setBannerClosed} />}
			{isAndroidPhoneUserAgent && androidEnabled && (
				<AndroidBanner sourceLocation={sourceLocation} setBannerClosed={setBannerClosed} />
			)}
			{!isMobileUserAgent && <DesktopBanner sourceLocation={sourceLocation} setBannerClosed={setBannerClosed} />}
		</>
	);
};
